import { Directive, HostListener, ElementRef, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector: '[dateMask]',
})
export class DateMaskDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) { }

  @HostListener('keypress', ['$event'])
  onKeypress(e: KeyboardEvent): void {
    if (!/\d/.test(e.key)) {
      e.preventDefault();
    }
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    let digits = input.value.replace(/\D/g, '').slice(0, 8);

    if (digits.length >= 2) {
      let day = parseInt(digits.slice(0, 2), 10);
      if (day > 31) day = 31;
      if (day < 1 && digits.slice(0, 2) !== '0' && digits.slice(0, 2) !== '00') day = 1;
      digits = String(day).padStart(2, '0') + digits.slice(2);
    }

    if (digits.length >= 4) {
      let month = parseInt(digits.slice(2, 4), 10);
      if (month > 12) month = 12;
      if (month < 1 && digits.slice(2, 4) !== '0' && digits.slice(2, 4) !== '00') month = 1;
      digits = digits.slice(0, 2) + String(month).padStart(2, '0') + digits.slice(4);
    }

    if (digits.length > 4) {
      input.value = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    } else if (digits.length > 2) {
      input.value = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    } else {
      input.value = digits;
    }

    this.ngControl?.control?.setValue(input.value, { emitEvent: true });
  }
  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement;
    const value = input.value;

    if (!value) return;

    const parsed = moment(value, 'DD/MM/YYYY', true);

    if (parsed.isValid()) {
      const currentYear = moment().year();
      const minYear = 1950;
      const year = parsed.year();
      const normalizedYear = Math.max(minYear, Math.min(currentYear, year));

      if (normalizedYear !== year) {
        parsed.year(normalizedYear);
      }

      const formatted = parsed.format('DD/MM/YYYY');
      input.value = formatted;
      this.ngControl?.control?.setValue(formatted, { emitEvent: true });
    } else {
      this.ngControl?.control?.markAsTouched();
      this.ngControl?.control?.setErrors({ invalidDate: { text: value } });
    }
  }
}
